import { ErrorConfig } from '../models/error-config.model';
import { LoginSsoErrorTypes } from '../models/login-sso-error-types.enum';

export const ssoErrorConfigs: Record<LoginSsoErrorTypes, ErrorConfig> = {
  [LoginSsoErrorTypes.AccessDenied]: {
    title: 'LOGIN.ERRORS.AUTHORIZE_PROFILE_ACCESS',
    description: 'LOGIN.ERRORS.AUTHORIZE_PROFILE_ACCESS_DESCRIPTION',
    nameButton: 'LOGIN.ERRORS.TRY_LOGGING_IN_AGAIN',
  },
  [LoginSsoErrorTypes.OauthFailed]: {
    title: 'LOGIN.ERRORS.CAN_NOT_CONNECT',
    description: 'LOGIN.ERRORS.CAN_NOT_CONNECT_DESCRIPTION',
    nameButton: 'LOGIN.ERRORS.TRY_LOGGING_IN_AGAIN',
  },
  [LoginSsoErrorTypes.OtherErrors]: {
    title: 'LOGIN.ERRORS.LOGIN_FAILED',
    description: 'LOGIN.ERRORS.LOGIN_FAILED_DESCRIPTION',
    nameButton: 'LOGIN.ERRORS.CONTACT_SUPPORT',
  },
};
